/************************************************************
 Global Functions Scope
 ************************************************************/

window.GlobalFn = {
    getFileInputValue: function(elem, defaultValue) {
		var fullPath = $(elem).val(), filename = "";

		if(fullPath){
			var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
			filename = fullPath.substring(startIndex);

			if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
				filename = filename.substring(1);
			}
		} else if(defaultValue){
            filename = defaultValue;
        }

		return filename;
	},
	getCellProps: function (taskDate, serverDate) {
		var timeDiff, bgColor, textColor, serverTime, taskTime;

		if (serverDate != null) {
			serverTime = new Date(serverDate.substr(0, 4),
				serverDate.substr(4, 2) - 1,
				serverDate.substr(6, 2),
				serverDate.substr(8, 2),
				serverDate.substr(10, 2));
		} else {
			serverTime = Hades.currentDate();
		}

		taskTime = new Date(taskDate?.substr(0, 4),
			taskDate.substr(4, 2) - 1,
			taskDate.substr(6, 2),
			taskDate.substr(8, 2),
			taskDate.substr(10, 2));




        timeDiff = taskTime - serverTime;

		//timeDiff = taskTime - serverTime;


		if (timeDiff > 0) {
			bgColor = '#829664';
			textColor = 'white';
		} else {
			//timeDiff *= -1;
			bgColor = '#C86464';
			textColor = 'white';
		}

		return {timeDiff:timeDiff, bgColor:bgColor, textColor:textColor}
	},
    getWaitingCellProps: function (serverDate, taskDate, levels) {
        if (serverDate != null) {
            var serverTime = new Date(serverDate.substr(0, 4),
                serverDate.substr(4, 2) - 1,
                serverDate.substr(6, 2),
                serverDate.substr(8, 2),
                serverDate.substr(10, 2));
        } else {
            serverTime = Hades.currentDate();
        }

        var taskTime = new Date(taskDate.substr(0, 4),
            taskDate.substr(4, 2) - 1,
            taskDate.substr(6, 2),
            taskDate.substr(8, 2),
            taskDate.substr(10, 2));

        var diff = (serverTime.getTime() - taskTime.getTime()) / 1000;
        var diff = Math.abs(diff);

        var optimum = (parseInt(levels[2]) * 60);
        var warning = (parseInt(levels[1]) * 60);
        var danger = (parseInt(levels[0]) * 60);

        /*debug.log('getWaitingCellProps serverDate', serverDate);
        debug.log('getWaitingCellProps taskDate', taskDate);
        debug.log('getWaitingCellProps levels', levels);
        debug.log('getWaitingCellProps diff', diff);
        debug.log('getWaitingCellProps levels to diff compare', optimum, warning, danger);*/

        var bg_color = '';

        if (diff >= danger){
            bg_color = '#C86464';
        }
        else if (diff >= warning) {
            bg_color = '#FAA732';
        }
        else if (diff >= optimum) {
            bg_color = 'rgb(0, 160, 175)';
        }
        else {
            bg_color = '#829664';
        }
        return bg_color;
	},
	onWorkflowActionSelect: function (elem, gridId, colName, wfId, wfStatusId, taskId) {

		var models = $('#' + gridId).jqGrid('getGridParam', 'colModel'), model;

		for (var i = 0; i < models.length; i++) {
			if (models[i].name == colName) {
				model = models[i];
				break;
			}
		}

        var params = {
            task_id: taskId,
            wf_id: wfId,
            wf_status_id: wfStatusId
        };

        if(model.params){
            $.extend(params, model.params);
        }

		Hades.getWorkflowActions(taskId, wfId, wfStatusId, elem, model.actionsAlign, gridId, model.actionClickCallback, params);

	},
	onContextualWorkflowActionClick: function (action) {
		workflow.executeAction(action, function (success) {
			if (success) {
				// Get values from contextual bar and refresh episode info
				Hades.updateContextualHeader({id:$("#contextual-id").val(), type:$("#contextual-id-type").val(), wf_id:action.wf_id, area_id:Hades.appArea()});
			}

			Hades.hideLoading();
		});
	},
	onEpisodeWorkflowActionClick: function (action) {
        Hades.showLoading();

        //debug.log('onEpisodeWorkflowActionClick -> Action', action);

		var wfId = parseInt(action.wf_id), actionId = parseInt(action.wf_action_id);

		var row = {};
		row.task_id = action.task_id;
		row.wf_id = action.wf_id;
		row.wf_status_id = action.from_state_id;
		row.treatment_type_id = $('#contextual-treatment-type-id').val();
		row.task_date_str = $('#contextual-task-date').val();
		row.patient_id = $('#contextual-patient-id').val();
		row.appointment_type_id = $('#contextual-appointment-type-id').val();
		row.specialty_id = $('#contextual-specialty-id').val();
		row.resource_type_id = $('#contextual-resource-type-id').val();
		row.professional_id = $('#contextual-resource-id').val();
		row.financial_institution_id = $('#contextual-financial-institution-id').val();
		row.professional_name = $('#contextual-resource-desc').val();

        //debug.log('onEpisodeWorkflowActionClick -> row', row);


		// Physiotherapy
		if (wfId == 7 || wfId == 8) {
            physiotherapy.executeAction(action, row, function (success) {
                if (success) {
                    // Get values from contextual bar and refresh episode info
                    Hades.updateContextualHeader({
                        id: $('#contextual-episode-id').val(),
                        type: 'episode',
                        wf_id: action.wf_id,
                        area_id: Hades.appArea()
                    });
                }

                Hades.hideLoading();
            });
        } else if (wfId == 38 || wfId == 53 || wfId == 43) {
		    //debug.log('Consult Process');
            workflow.executeAction(action, function (success) {

                //debug.log('comming fiels', success, action_comming, row_comming);

                if (success) {
                    // Get values from contextual bar and refresh episode info
                    Hades.updateContextualHeader({id:$('#contextual-episode-id').val(), type:'episode', wf_id:action.wf_id, area_id:Hades.appArea()});

                    /*var _type = 'episode';
                    var _wf_id = 2;
                    var _id = $('#contextual-episode-id').val();

                    debug.log('send fiels', _id, _type, _wf_id);

                    Hades.updateContextualHeader({id: _id, type:_type, wf_id: _wf_id, area_id: Hades.appArea()});*/
                }

                Hades.hideLoading();
            }, row);
          }
		else {
			var params = {task_id:action.task_id,
				wf_id:action.wf_id,
				wf_status_id:action.to_state_id,
				wf_action_id:action.wf_action_id};

			// Cancel Episode
			if ( (actionId == 3 && wfId != 57) ) {

                //debug.log('PARAMS before Cancel: ', params);
                $.get('/modal/generic_reason_window', params, null, "html")
                    .done(function (data, status, xhr) {
                        Hades.checkIfUserIsAuthorized(data, status, xhr);

                        $.fancybox({content: data, autoScale: true, autoDimensions: true});

                        $('#generic-reason-modal-ct').bind('genericReasonConfirmed', GlobalFn.cancelEpisode);

                        Hades.hideLoading();
                    })
                    .fail(function (xhr, status, error) {
                        Hades.showError(error, xhr.responseText, xhr, status, error);
                        Hades.hideLoading();
                    });

            }else if (wfId == 57 && actionId == 3){

			    //debug.log('cancel mcdt episode');
                mcdtNS.executeAction(action, row, function (success) {
                    if (success) {
                        // Get values from contextual bar and refresh episode info
                        Hades.updateContextualHeader({id:$('#contextual-episode-id').val(), type:'episode', wf_id:action.wf_id, area_id:Hades.appArea()});
                    }

                    Hades.hideLoading();
                });

			} else if (wfId == 44 && actionId == 4){

                    var type = 'episode';
                    if(row.task_type_id == "0"){ //row.wf_id == 1 //row.wf_id != 44
                        type = 'appointment';
                    }

                    var params = {
                        id: row.task_id,
                        wf_id: row.wf_id,
                        type: type
                    };

                    //debug.log('PARAMS: /consult/update_smap_consult', params);

                    $.post('/consult/update_smap_consult', params, null, 'json')
                        .done(function (data, status, xhr) {
                            Hades.checkIfUserIsAuthorized(data, status, xhr);

                            if (data.success != true) {
                                Hades.showError(Hades.genericErrorMsg(), data.error);
                                Hades.hideLoading();
                            } else {
                                workflow.executeAction(action, function (success) {
                                    if (success) {
                                        // Get values from contextual bar and refresh episode info
                                        Hades.updateContextualHeader({id:$('#contextual-episode-id').val(), type:'episode', wf_id:action.wf_id, area_id:Hades.appArea()});
                                    }

                                    Hades.hideLoading();
                                });
                            }
                        })
                        .fail(function (xhr, status, error) {
                            Hades.showError(error, xhr.responseText, xhr, status, error);
                            Hades.hideLoading();
                        });
            }//Undo Start Episode
            else if ( (actionId == 99 && wfId != 57 ) || (actionId == 100 && wfId != 57 ) || (actionId == 109 && wfId != 57 ) || (actionId == 110 && wfId != 57) ) {
                episode.executeAction(action, row, function (success) {
                    if (success) {
                        // Get values from contextual bar and refresh episode info
                        Hades.updateContextualHeader({id:$('#contextual-episode-id').val(), type:'episode', wf_id:action.wf_id, area_id:Hades.appArea()});
                    }

                    Hades.hideLoading();
                });
            }
            else if (  (wfId == 57  && actionId == 99) || (wfId == 57  && actionId == 100) || (wfId == 57  && actionId == 109) || (wfId == 57  && actionId == 110) ) {
                mcdtNS.executeAction(action, row, function (success) {
                    if (success) {
                        // Get values from contextual bar and refresh episode info
                        Hades.updateContextualHeader({id:$('#contextual-episode-id').val(), type:'episode', wf_id:action.wf_id, area_id:Hades.appArea()});
                    }

                    Hades.hideLoading();
                });
            }
            else if ( (actionId == 17 && wfId != 57) ){


                episode.executeAction(action, row, function(sucess, action, row){

                    var _type = 'episode';
                    var _wf_id = 2;
                    var _id = $('#contextual-episode-id').val();



                    Hades.updateContextualHeader({id:_id, type:_type, wf_id:_wf_id, area_id:Hades.appArea()})
                });
            }
            else if ( (actionId == 17 &&  wfId == 57 ) ){

                mcdtNS.executeAction(action, row, function(sucess, action, row){

                    var _type = 'episode';
                    var _wf_id = 57;
                    var _id = $('#contextual-episode-id').val();


                    Hades.updateContextualHeader({id:_id, type:_type, wf_id:_wf_id, area_id:Hades.appArea()})
                });
            }

            else if (actionId == 5 && wfId == 44){


                episode.executeAction(action, row, function(sucess, action, row){
                    var _type = 'episode';
                    var _wf_id = 44;
                    var _id = $('#contextual-episode-id').val();

                    Hades.updateContextualHeader({id:_id, type:_type, wf_id:_wf_id, area_id:Hades.appArea()})
                });


            }
            else if (actionId == 126 && wfId == 2){

                episode.executeAction(action, row, function(sucess, action, row){
                    var _type = 'episode';
                    var _wf_id = 2;
                    var _id = $('#contextual-episode-id').val();

                    Hades.updateContextualHeader({id:_id, type:_type, wf_id:_wf_id, area_id:Hades.appArea()})
                });

            }else if (actionId == 127 && wfId == 2){

                //debug.log("ENTREGA");
                // episode.executeAction(action, row, callback);

                episode.executeAction(action, row, function(sucess, action, row){
                    var _type = 'episode';
                    var _wf_id = 44;
                    var _id = $('#contextual-episode-id').val();

                    Hades.updateContextualHeader({id:_id, type:_type, wf_id:_wf_id, area_id:Hades.appArea()})
                });

            } else if (actionId == globalConstants.ACTION_FINALIZE_EPISODE && wfId == globalConstants.WF_EPISODE){

                episode.executeAction(action, row, function(sucess, action, row){
                    var _type = 'episode';
                    var _wf_id = globalConstants.WF_EPISODE;
                    var _id = $('#contextual-episode-id').val();

                    Hades.updateContextualHeader({id:_id, type:_type, wf_id:_wf_id, area_id:Hades.appArea()})
                });

            }

            // Other actions}
            else {

                //debug.log('OTHER ACTIONS JF', wfId);
				workflow.executeAction(action, function (success) {

                    //debug.log('comming fiels', success, action_comming, row_comming);

					if (success) {
						// Get values from contextual bar and refresh episode info
						//Hades.updateContextualHeader({id:$('#contextual-episode-id').val(), type:'episode', wf_id:action.wf_id, area_id:Hades.appArea()});

                        var _type = 'episode';
                        var _wf_id = 2;
                        var _id = $('#contextual-episode-id').val();

                        //debug.log('send fiels', _id, _type, _wf_id);

                        Hades.updateContextualHeader({id: _id, type:_type, wf_id: _wf_id, area_id: Hades.appArea()});
					}

					Hades.hideLoading();
				}, row);
			}
		}
	},

    onViewerWorkflowActionClick: function (action) {
        Hades.showLoading();

        $.getJSON('/hades/get_task_context', {id:action.task_id, wf_id:action.wf_id})
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                var row = {}, wfId = parseInt(action.wf_id), actionId = parseInt(action.wf_action_id);
                row.task_id = action.task_id;
                row.wf_id = action.wf_id;
                row.wf_status_id = action.from_state_id;
                row.treatment_type_id = data.treatment_type_id;
                row.task_date_str = data.task_date_str;
                row.patient_id = data.patient_id;
                row.appointment_type_id = data.appointment_type_id;
                row.specialty_id = data.specialty_id;
                row.resource_type_id = data.resource_type_id;
                row.professional_id = data.resource_id;
                row.financial_institution_id = data.financial_institution_id;
                row.professional_name = data.resource_name;

                // Physiotherapy
                if (wfId == 7 || wfId == 8) {

                    physiotherapy.executeAction(action, row, function (success) {
                        if (success) {
                            // Get values from contextual bar and refresh episode info
                            Hades.updateContextualHeader({id:$('#contextual-id').val(), type:$('#contextual-id-type').val(), wf_id:$('#contextual-wf-id').val(), area_id:Hades.appArea()});
                        }

                        Hades.hideLoading();
                    });
                } else if ((parseInt(action.wf_id) == 1 && parseInt(action.wf_action_id) == 2) || (parseInt(action.wf_id) == 2 && parseInt(action.wf_action_id) == 17)) {

                    episode.executeAction(action, row, function(success, action) {
                        if (success) {
                            // Reload
                            Hades.updateContextualHeader({id:$('#contextual-id').val(), type:$('#contextual-id-type').val(), wf_id:$('#contextual-wf-id').val(), area_id:Hades.appArea()});
                        }

                        Hades.hideLoading();
                    });
                } else {
                    var params = {
                        task_id:action.task_id,
                        wf_id:action.wf_id,
                        wf_status_id:action.to_state_id,
                        wf_action_id:action.wf_action_id
                    };

                    // Cancel Episode
                    if (actionId == 3) {

                        $.get('/modal/generic_reason_window', params, null, "html")
                            .done(function (data, status, xhr) {
                                Hades.checkIfUserIsAuthorized(data, status, xhr);

                                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', GlobalFn.cancelViewerEpisode);

                                Hades.hideLoading();
                            })
                            .fail(function (xhr, status, error) {
                                Hades.showError(error, xhr.responseText, xhr, status, error);
                                Hades.hideLoading();
                            });
                    } else {
                        workflow.executeAction(action, function (success) {
                            if (success) {
                                // Get values from contextual bar and refresh episode info
                                Hades.updateContextualHeader({id:$('#contextual-id').val(), type:$('#contextual-id-type').val(), wf_id:$('#contextual-wf-id').val(), area_id:Hades.appArea()});

                                Hades.reloadViewerScreen();
                            }

                            Hades.hideLoading();
                        });
                    }
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
	onPhysiotherapyWorkflowActionClick: function (action) {

		Hades.showLoading();

		var row = {};
		row.task_id = action.task_id;
		row.wf_id = action.wf_id;
		row.wf_status_id = action.from_state_id;
		row.treatment_type_id = $('#contextual-treatment-type-id').val();
		row.task_date_str = $('#contextual-task-date').val();
		row.patient_id = $('#contextual-patient-id').val();
		row.appointment_type_id = $('#contextual-appointment-type-id').val();
		row.specialty_id = $('#contextual-specialty-id').val();
		row.resource_type_id = $('#contextual-resource-type-id').val();
		row.professional_id = $('#contextual-resource-id').val();
		row.financial_institution_id = $('#contextual-financial-institution-id').val();
		row.professional_name = $('#contextual-resource-desc').val();
        row.patient_type_id = action.patient_type_id;
        row.requisition_id =action.params.requisition_id ;

        //debug.log('Contextual',action);

        if (action.params.patient_type_id == -1) {
            bootbox.alert('Necessário definir o tipo de utente para finalizar o processo');
            Hades.hideLoading()
            return false;
        }

		physiotherapy.executeAction(action, row, function (success, action) {
			if (success) {
				// Get values from contextual bar and refresh episode info
				Hades.updateContextualHeader({id:action.task_id, type:'physiotherapy', wf_id:action.wf_id, area_id:Hades.appArea()});
			}

			Hades.hideLoading();
		});

	},
    onSurgicalProcessWorkflowActionClick: function (action) {
        var row = {};
        row.task_id = action.task_id;
        row.wf_id = action.wf_id;
        row.wf_status_id = action.from_state_id;
        row.treatment_type_id = $('#contextual-treatment-type-id').val();
        row.task_date_str = $('#contextual-task-date').val();
        row.patient_id = $('#contextual-patient-id').val();
        row.appointment_type_id = $('#contextual-appointment-type-id').val();
        row.specialty_id = $('#contextual-specialty-id').val();
        row.resource_type_id = $('#contextual-resource-type-id').val();
        row.professional_id = $('#contextual-resource-id').val();
        row.financial_institution_id = $('#contextual-financial-institution-id').val();


        //debug.log('row_surg', row);

        surgeryProcessNS.executeAction(action, row, function (success) {
            if (success) {
                Hades.reloadContextualHeader();
            }
        });
    },
	onMishapWorkflowActionClick: function (action) {

		var params = {
			task_id:action.task_id,
			wf_id:action.wf_id,
			wf_status_id:action.to_state_id,
			wf_action_id:action.wf_action_id};

		// Cancel Mishap
		if (parseInt(action.wf_action_id) == 3) {
            Hades.showLoading();

			$.get('/modal/generic_reason_window', params, null, "html")
				.done(function (data, status, xhr) {
					Hades.checkIfUserIsAuthorized(data, status, xhr);

					$.fancybox({content:data, autoScale:true, autoDimensions:true});

					$('#generic-reason-modal-ct').bind('genericReasonConfirmed', GlobalFn.cancelMishap);

					Hades.hideLoading();
				})
				.fail(function (xhr, status, error) {
					Hades.showError(error, xhr.responseText, xhr, status, error);
					Hades.hideLoading();
				});

		}
        // Finalize Mishap
        else if (parseInt(action.wf_action_id) == 12) {
            Hades.showLoading();

            $.get('/mishap/finalize_mishap_modal', params, null, "html")
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    $.fancybox({content:data, autoScale:true, autoDimensions:true});

                    $('#finalize-mishap-modal-ct').bind('onConfirmed', GlobalFn.finalizeMishap);

                    Hades.hideLoading();
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    Hades.hideLoading();
                });

        }
		// Reopen Mishap
		else if (parseInt(action.wf_action_id) == 14) {

			$.get('/mishap/reopen_mishap_modal', params, null, "html")
				.done(function (data, status, xhr) {
					Hades.checkIfUserIsAuthorized(data, status, xhr);

					$.fancybox({content:data, autoScale:true, autoDimensions:true});

					$('#reopen-mishap-modal-ct').bind('reopenMishapConfirmed', GlobalFn.reopenMishap);

					Hades.hideLoading();
				})
				.fail(function (xhr, status, error) {
					Hades.showError(error, xhr.responseText, xhr, status, error);
					Hades.hideLoading();
				});

		} else {
			workflow.executeAction(action, function (success) {
				if (success) {
					// Get values from contextual bar and refresh episode info,
					Hades.updateContextualHeader({id:$('#contextual-treatment-id').val(), type:'mishap', wf_id:action.wf_id, area_id:Hades.appArea()});
				}

				Hades.hideLoading();
			});
		}
	},
	cancelEpisode: function (event, data) {

		$.fancybox.close(true);

		var params = {
            //task_id:$('#contextual-episode-id').val(),
            task_id: data.taskId,
			reason_id:data.reasonId,
			other_reason:data.otherReason,
			cancel_date:data.date,
			cancel_hour:data.hour,
			//wf_id:$('#contextual-wf-id').val(),
			//wf_status_id:$('#contextual-wf-status-id').val(),
            wf_id: data.wf_id,
            wf_status_id: data.wf_status_id,
			wf_action_id:data.actionId};

        //debug.log('cancelEpisode: ', data);

		$.post('/episode/cancel_episode', params, null, 'json')
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

                 if ($('#contextual-wf-id').val() == 1) {
				    // Get values from contextual bar and refresh episode info
				    //Hades.updateContextualHeader({id:$('#contextual-episode-id').val(), type:'episode', wf_id:$('#contextual-wf-id').val(), area_id:Hades.appArea()});
                    Hades.updateContextualHeader({id:$('#contextual-appointment-id').val(), type:'episode', wf_id:$('#contextual-wf-id').val(), area_id:Hades.appArea()});
                    }
                else{
                     Hades.updateContextualHeader({id:$('#contextual-episode-id').val(), type:'episode', wf_id:$('#contextual-wf-id').val(), area_id:Hades.appArea()});
                 }

                Hades.reloadViewerScreen();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});

	},

    cancelViewerEpisode: function (event, data) {

        $.fancybox.close(true);

        var params = {
            task_id:data.taskId,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:data.wf_id,
            wf_status_id:data.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/episode/cancel_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                // Get values from contextual bar and refresh episode info
                Hades.updateContextualHeader({id:$('#contextual-id').val(), type:$('#contextual-id-type').val(), wf_id:$('#contextual-wf-id').val(), area_id:Hades.appArea()});
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });

    },
    finalizeMishap: function(event, data) {
        $.fancybox.close(true);

        Hades.showLoading();

        $.post('/mishap/save_discharge_info', data, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                } else {
                    // Get values from contextual bar and refresh episode info
                    Hades.updateContextualHeader({id:$('#contextual-mishap-treatment-id').val(), type:'mishap', wf_id:$('#contextual-wf-id').val(), area_id:Hades.appArea()});
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
	cancelMishap: function (event, data) {

		$.fancybox.close(true);

        Hades.showLoading();

		var params = {
            task_id:$('#contextual-mishap-treatment-id').val(),
			reason_id:data.reasonId,
			other_reason:data.otherReason,
			cancel_date:data.date,
			cancel_hour:data.hour,
			wf_id:$('#contextual-wf-id').val(),
			wf_status_id:$('#contextual-wf-status-id').val(),
			wf_action_id:data.actionId
        };

		$.post('/mishap/cancel_mishap', params, null, 'json')
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

                Hades.hideLoading();

				// Get values from contextual bar and refresh episode info
				Hades.updateContextualHeader({id:$('#contextual-mishap-treatment-id').val(), type:'mishap', wf_id:$('#contextual-wf-id').val(), area_id:Hades.appArea()});
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	},
	reopenMishap: function (event, data) {

		$.fancybox.close(true);

		var params = {
            task_id:$('#contextual-mishap-treatment-id').val(),
			reason_id:data.reasonId,
			other_reason:data.otherReason,
			reopen_date:data.date,
			reopen_hour:data.hour,
            wf_id:$('#contextual-wf-id').val(),
            wf_status_id:$('#contextual-wf-status-id').val(),
			wf_action_id:data.actionId,
            authorized_by: data.authorized_by
        };
        //debug.log('reopenMishap', params);
        
		$.post('/mishap/reopen_mishap', params, null, 'json')
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				if (data.success != true) {
					Hades.showError(Hades.genericErrorMsg(), data.error);
					Hades.hideLoading();
				} else {
					// Get values from contextual bar and refresh episode info
                    Hades.updateContextualHeader({id:$('#contextual-mishap-treatment-id').val(), type:'mishap', wf_id:$('#contextual-wf-id').val(), area_id:Hades.appArea()});
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});

	},
    onInpatientWorkflowActionClick: function (action) {
        var params = {
            task_id:action.task_id,
            wf_id:action.wf_id,
            wf_status_id:action.to_state_id,
            wf_action_id:action.wf_action_id};

        inpatientNS.executeAction(action, params, function (success) {
            if (success) {
                Hades.reloadContextualHeader();
            }

            Hades.hideLoading();
        });
    },
    onSurgeryWorkflowActionClick: function (action) {
        var params = {
            task_id:action.task_id,
            wf_id:action.wf_id,
            wf_status_id:action.to_state_id,
            wf_action_id:action.wf_action_id};

        operatingRoomNS.executeAction(action, params, function (success) {
            if (success) {
                Hades.reloadContextualHeader();
            }

            if( action.wf_action_id != 97 && (Hades.appArea() == 25 || Hades.appArea() == 26) ){
                Hades.reloadScreen({go_to_status_id:action.to_state_id});
            } else {
                Hades.hideLoading();
            }
        });
    },

    /*get_translation_for: function (key) {

        $.get('/khis_util/get_translation_js', {key: key}, null, "html")
            .done(function(data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                var _data = $.parseJSON(data);
                debug.log('get_translation_for', _data, _data.app_label);
                return _data.app_label;
            });
    },*/

    onConsultProcessWorkflowActionClick: function (action) {
        var row = {};
        row.task_id = action.task_id;
        row.wf_id = action.wf_id;
        row.wf_status_id = action.from_state_id;
        row.treatment_type_id = $('#contextual-treatment-type-id').val();
        row.task_date_str = $('#contextual-task-date').val();
        row.patient_id = $('#contextual-patient-id').val();
        row.appointment_type_id = $('#contextual-appointment-type-id').val();
        row.specialty_id = $('#contextual-specialty-id').val();
        row.resource_type_id = $('#contextual-resource-type-id').val();
        row.professional_id = $('#contextual-resource-id').val();
        row.financial_institution_id = $('#contextual-financial-institution-id').val();


        //debug.log('row_surg', row);

        workflow.executeAction(action, function (success) {
            if (success) {
                Hades.reloadContextualHeader();
            }
        }, row);

        /*consultProcessNS.executeAction(action, row, function (success) {

        });*/


    },

    onMcdtProcessWorkflowActionClick: function (action) {
        var row = {};
        row.task_id = action.task_id;
        row.wf_id = action.wf_id;
        row.wf_status_id = action.from_state_id;
        row.treatment_type_id = $('#contextual-treatment-type-id').val();
        row.task_date_str = $('#contextual-task-date').val();
        row.patient_id = $('#contextual-patient-id').val();
        row.appointment_type_id = $('#contextual-appointment-type-id').val();
        row.specialty_id = $('#contextual-specialty-id').val();
        row.resource_type_id = $('#contextual-resource-type-id').val();
        row.professional_id = $('#contextual-resource-id').val();
        row.financial_institution_id = $('#contextual-financial-institution-id').val();


        //debug.log('row_mcdt', row);

        workflow.executeAction(action, function (success) {
            if (success) {
                Hades.reloadContextualHeader();
                Hades.reloadScreen();
            }
        }, row);

    },

    onEligibilityProcessWorkflowActionClick: function (action) {
        var row = {};
        row.task_id = action.task_id;
        row.wf_id = action.wf_id;
        row.wf_status_id = action.from_state_id;
        row.elegibility_request_id = $('#contextual-elegibility-request-id').val();
        row.patient_id = $('#contextual-patient-id').val();
        row.financial_institution_id = $('#contextual-financial-institution-id').val();

        //debug.log('row_eligibility_request', row);

        workflow.executeAction(action, function (success) {
            if (success) {
                Hades.reloadContextualHeader();
            }
        }, row);

    },


    onReimbursementProcessWorkflowActionClick: function (action) {

        var row = {};
        row.task_id = action.task_id;
        row.wf_id = action.wf_id;
        row.wf_status_id = action.from_state_id;
        row.elegibility_request_id = $('#contextual-hcp_reimbursement-request-id').val();
        row.patient_id = $('#contextual-patient-id').val();
        row.financial_institution_id = $('#contextual-financial-institution-id').val();

        //debug.log('row_eligibility_request', row);

        workflow.executeAction(action, function (success) {
            if (success) {
                Hades.reloadContextualHeader();
            }
        }, row);

    },

    onDentalProcessWorkflowActionClick: function (action) {
        var row = {};
        row.task_id = action.task_id;
        row.wf_id = action.wf_id;
        row.wf_status_id = action.from_state_id;
        row.treatment_type_id = $('#contextual-treatment-type-id').val();
        row.task_date_str = $('#contextual-task-date').val();
        row.patient_id = $('#contextual-patient-id').val();
        row.appointment_type_id = $('#contextual-appointment-type-id').val();
        row.specialty_id = $('#contextual-specialty-id').val();
        row.resource_type_id = $('#contextual-resource-type-id').val();
        row.professional_id = $('#contextual-resource-id').val();
        row.financial_institution_id = $('#contextual-financial-institution-id').val();


        //debug.log('row_surg', row);

        dentalMedicineMedicalActNS.executeAction(action, row, function (success) {
            if (success) {
                Hades.reloadContextualHeader();
            }
        });
    },

	validateForm: function (formId, partialValidation, currField, scope, addErrorClass) {
        //debug.log("validateForm formId", formId, partialValidation, currField, scope, addErrorClass);
        if (partialValidation == true && !$(currField).hasClass('error')) {
            return false;
        }
		if (!scope) {
			scope = '#' + formId;
		}

        if (!addErrorClass) {
            addErrorClass = true;
		}

        //debug.log('mandatoryFields', scope, addErrorClass);
		var valid = true, field, mandatoryFields = $(scope + ' .form_field_mandatory');
        //debug.log('mandatoryFields', mandatoryFields);

        var emptyFieldError = GlobalTranslations.emptyFieldError;
        var shortValueError = GlobalTranslations.shortValueError;
        var maxValueError = GlobalTranslations.maxValueError;
        var cloneValueError = GlobalTranslations.cloneValueError;
        var numericValueError = GlobalTranslations.numericValueError;
        var dateValueError = GlobalTranslations.dateValueError;
        var hourValueError = GlobalTranslations.hourValueError;
        var numericOutOfRangeError =GlobalTranslations.numericOutOfRangeError;

		var errors = [];
		var showErrors = false;

		// Delete erros only if errors are already visible
		if (!partialValidation || $('#' + formId + '-messages').children().size() > 0) {
			showErrors = true;
			$('#' + formId + '-messages').empty();
		}

        $(scope + ' input').removeClass('error');
        $(scope + ' select').removeClass('error');
        $(scope + ' textarea').removeClass('error');
        $(scope + ' .chzn-container a.chzn-single').removeClass('error');

        // Check clone fields
        var cloneFields = $(scope + ' [form-field-clone]:not([disabled])');
        for (var i = 0; i < cloneFields.length; i++) {
            field = $(cloneFields[i]);

            if (!field.hasClass('error') && (field.val() != $('#' + field.attr('form-field-clone')).val())) {
                valid = false;
                if(addErrorClass){
                    field.addClass('error');
                }

                if ($('label[for=' + field.attr('name') + ']').html()) {
                    errors.push((cloneValueError.replace('$2$', $('label[for=' + field.attr('name') + ']').html())).replace('$1$', $('label[for=' + $('#' + field.attr('form-field-clone')).attr('name') + ']').html()));
                }
            } else {
                field.removeClass('error');
            }
        }

        // Check min chars
        var fields = $(scope + ' [form-field-minchars]:not([disabled])');
        for (var i = 0; i < fields.length; i++) {
            field = $(fields[i]);

            if (!field.hasClass('error') && (field.val() != null && field.val() != '' && field.val().trim().length < parseInt(field.attr('form-field-minchars')))) {
                valid = false;
                if(addErrorClass){
                    field.addClass('error');
                }

                if ($('label[for=' + field.attr('name') + ']').html()) {
                    errors.push((shortValueError.replace('$2$', field.attr('form-field-minchars'))).replace('$1$', $('label[for=' + field.attr('name') + ']').html()));
                }
            } else {
                field.removeClass('error');
            }
        }

        // Check max chars
        var fields = $(scope + ' [form-field-maxchars]:not([disabled])');
        for (var i = 0; i < fields.length; i++) {
            field = $(fields[i]);

            if (!field.hasClass('error') && (field.val() != null && field.val() != '' && field.val().trim().length > parseInt(field.attr('form-field-maxchars')))) {
                valid = false;
                if(addErrorClass){
                    field.addClass('error');
                }

                if ($('label[for=' + field.attr('name') + ']').html()) {
                    errors.push((maxValueError.replace('$2$', field.attr('form-field-maxchars'))).replace('$1$', $('label[for=' + field.attr('name') + ']').html()));
                }
            } else {
                field.removeClass('error');
            }
        }

        // Check numeric fields
        var fields = $(scope + ' [form-field-numeric]:not([disabled])'), invalid;

        for (var i = 0; i < fields.length; i++) {
            field = $(fields[i]);

            if(field.attr('form-field-numeric-integer') == 'true'){
                invalid = String(field.val()).search(/^(-|)(\d+)$/);
            } else {
                invalid = String(field.val()).search(/^(-|)(\d+\.\d+|\d+,\d+|\d+)$/);
            }


            if (!field.hasClass('error') && (field.val() == null || field.val() == '' || parseInt(invalid) != -1)) {
                field.removeClass('error');

                // Check numeric range
                var range = field.attr('form-field-numeric').split(';');
                if (range[0] == "range") {
                    if (parseFloat(range[1]) > parseFloat(field.val()) || parseFloat(field.val()) > parseFloat(range[2])) {
                        valid = false;
                        if(addErrorClass){
                            field.addClass('error');
                        }

                        if ($('label[for=' + field.attr('name') + ']').html()) {
                            errors.push(numericOutOfRangeError.replace('$1$', $('label[for=' + field.attr('name') + ']').html()).replace('$2$', range[1]).replace('$3$', range[2]));
                        }
                    }
                }
            } else {
                valid = false;
                if(addErrorClass){
                    field.addClass('error');
                }

                if ($('label[for=' + field.attr('name') + ']').html()) {
                    errors.push(numericValueError.replace('$1$', $('label[for=' + field.attr('name') + ']').html()));
                }
            }
        }

        // Check date fields
        var fields = $(scope + ' .date_input:not([disabled])'), invalid;
        for (var i = 0; i < fields.length; i++) {

            field = $(fields[i]);
            invalid = String(field.val()).search(/^((\d+\d+|\d+)-(\d+\d+|\d+)-\d+\d+\d+\d+|\d+\d+\d+\d+-(\d+\d+|\d+)-(\d+\d+|\d+)|(\d+\d+|\d+)\/(\d+\d+|\d+)\/\d+\d+\d+\d+|\d+\d+\d+\d+\/(\d+\d+|\d+)\/(\d+\d+|\d+))$/);

            if (!field.hasClass('error') && (field.val() == null || field.val() == '' || parseInt(invalid) != -1)) {
                if(field.hasClass('form_field_mandatory') && !field.hasClass('error')){
                    field.removeClass('error');
                }
            } else {
                valid = false;
                if(addErrorClass){
                    field.addClass('error');
                }

                if ($('label[for=' + field.attr('name') + ']').html()) {
                    errors.push(dateValueError.replace('$1$', $('label[for=' + field.attr('name') + ']').html()));
                }
            }
        }

        // Check hour fields
        var fields = $(scope + ' .hour_input:not([disabled])'), invalid;
        for (var i = 0; i < fields.length; i++) {
            field = $(fields[i]);

            var
                pattern = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/g,
                testResult = pattern.test(field.val());

            if (!field.hasClass('error') && (field.val() == null || field.val() == '' || testResult)) {
                field.removeClass('error');
            } else {
                valid = false;
                if(addErrorClass){
                    field.addClass('error');
                }

                if ($('label[for=' + field.attr('name') + ']').html()) {
                    errors.push(hourValueError.replace('$1$', $('label[for=' + field.attr('name') + ']').html()));
                }
            }
        }

        // Check files
        var fields = $(scope + ' input[type=file]'), max_img_size = Hades.getMaxUploadSize(), sizeError = Hades.getUploadSizeFormError();
        sizeError = sizeError.replace('#MAX_VALUE#', max_img_size);

        for (var i = 0; i < fields.length; i++) {
            field = fields[i];

            if(field.files && field.files.length == 1){
                try {
                    if (field.files[0].size > max_img_size*1024*1024)
                    {
                        valid = false;
                        errors.push(sizeError.replace('#FILENAME#', field.files[0].name));
                    }
                } catch(ex){
                    debug.log(ex);
                }
            }
        }

        // Check mandatory fields
		for (var i = 0; i < mandatoryFields.length; i++) {

			field = $(mandatoryFields[i]);


            var additional_message = field.data('additional-message');

            if (additional_message === undefined) {
                additional_message = '';
            } else {
                additional_message = ' ' + field.data('additional-message');
            }

			switch (field.attr('type')) {
				case 'hidden':
					if (field.attr('value') == undefined || !(field.attr('value').length > 0)) {
						valid = false;
                        if(addErrorClass){
                            field.addClass('error');
                        }

						if ($('label[for=' + field.attr('name') + ']').html()) {
							errors.push(emptyFieldError.replace('$1$', $('label[for=' + field.attr('name') + ']').html())  + additional_message);
						}
					} else {
						field.removeClass('error');
					}
					break;

                case 'radio':
                    if ($("input[type=radio]:checked").length > 0 == false){
                        valid = false;
                        if(addErrorClass){
                            //debug.log("div: ",$(field).closest('div.form_value').addClass('error_div'));
                            //$(field).closest('div.form_value').addClass('error_div');
                            //field.addClass('error_div');
                            field.closest('form').addClass('error');
                            $(field).closest('div.form_value').css('padding-left','5px');
                            // debug.log("error:", field.addClass('error_radio') );
                        }

                        if ($('label[for=' + field.attr('name') + ']').html()) {
                            errors.push(emptyFieldError.replace('$1$', $('label[for=' + field.attr('name') + ']').html())  + additional_message);
                        }
                    } else {
                        field.removeClass('error');
                    }
                    break;


				case 'password':
				case 'text':
				case 'file':
                case 'number':
                    if (!field.val().trim().length > 0) {
                        field.val().trim().length
						valid = false;
                        if(addErrorClass){
                            field.addClass('error');
                        }

						if ($('label[for=' + field.attr('name') + ']').html()) {
							errors.push(emptyFieldError.replace('$1$', $('label[for=' + field.attr('name') + ']').html())  + additional_message);
						}
					} else {
						field.removeClass('error');
					}
					break;

				default:
				    //debug.log('default', field, field.get(0).tagName.toLowerCase());
					switch (field.get(0).tagName.toLowerCase()) {
						case 'textarea':
							if (!field.val().trim().length > 0) {
								valid = false;
                                if(addErrorClass){
                                    field.addClass('error');
                                }

								if ($('label[for=' + field.attr('name') + ']').html()) {
									errors.push(emptyFieldError.replace('$1$', $('label[for=' + field.attr('name') + ']').html()) + additional_message);
								}
							} else {
								field.removeClass('error');
							}
							break;

						case 'select':
							//var option = $('#' + field.attr('id') + ' option:selected').val();
                            var option = $(field).val();

							if (option == null || option === undefined || option == '' || option == "-1") {
								valid = false;
                                if(addErrorClass){
                                    field.addClass('error');

                                    if(field.hasClass('chzn-done')){
                                        $('#' + field.attr('id') + '_chzn a.chzn-single').addClass('error');
                                    }
                                }

								if ($('label[for=' + field.attr('name') + ']').html()) {
									errors.push(emptyFieldError.replace('$1$', $('label[for=' + field.attr('name') + ']').html()) + additional_message);
								}
							} else {
								field.removeClass('error');

                                if(field.hasClass('chzn-done')){
                                    $('#' + field.attr('id') + '_chzn a.chzn-single').removeClass('error');
                                }
							}
							break;

                        case 'form':
                            if (field.find("input[type=radio]:checked").length == 0){
                                valid = false;
                                if(addErrorClass){
                                    $(field).closest('div.form_value').addClass('error_div');
                                    field.addClass('error');
                                    $(field).closest('div.form_value').css('padding-left','5px');
                                }

                                if ($('label[for=' + field.attr('name') + ']').html()) {
                                    errors.push(emptyFieldError.replace('$1$', $('label[for=' + field.attr('name') + ']').html())  + additional_message);
                                }
                            } else {
                                $(field).closest('div.form_value').removeClass('error_div');
                                field.removeClass('error');
                            }
                            break;
					}
					break;
			}

		}

		// Delete errors only if errors are already visible
		if (!valid && showErrors && errors.length > 0) {
            let unique_errors = [];
            for (let err of errors) {
                if (!unique_errors.includes(err))
                    unique_errors.push(err);
            }

            GlobalFn.showFormErrors(formId, unique_errors);
		}

		return valid;
	},
    showFormErrors: function (formId, errorList) {
        var html = '<div class="alert alert-error"><a class="close" data-dismiss="alert" href="#">×</a><ul>';

        for (var i = 0; i < errorList.length; i++) {
            html += '<li>' + errorList[i] + '</li>';
        }
        html += '</ul></div>';

        $('#' + formId + '-messages').empty();
        $(html).appendTo('#' + formId + '-messages');

        try {
            if($('#' + formId + '-messages').data('scroll') && $('#' + formId + '-messages').data('scroll').length > 0){
                $('#' + $('#' + formId + '-messages').data('scroll')).animate({ scrollTop: 0 }, "fast");
            } else {
                //$('body').animate({scrollTop:0}, 'fast');
                window.scrollTo(0, 0);
            }
        } catch(ex) {
            debug.log(ex);
        }
    },
    clearFormErrors: function (formId) {
        $('#' + formId + '-messages').empty();
        $('#' + formId + ' .error').removeClass('error');
    },
	loadWidget: function(elem, requestParams) {
		var c = $(elem), w = $(elem).closest('.summary_widget'), params;

        if(requestParams){
            params = $.extend(requestParams, {widget:$(w).attr('id')});
        } else {
            params = {widget:$(w).attr('id')};
        }

		// Show loading
		w.find('.summary_widget_content_body').remove();
		w.find('.summary_widget_loading').hide().fadeIn();

        // Add params
        if(w.hasClass('tabs')){
            var activeTab = w.find('span.summary_widget_tab.active');
            params.widget_tab = $(activeTab).data('tab');
        }

		// Get data
		$.getJSON(c.data('url'), params)

			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				var headers = data.headers,
					rows = data.data,
					w = $('#' + data.widget),
					c = $('#' + data.widget + ' .summary_widget_content'),
					t = $('<table class="summary_widget_content_body" style="width: 100%;"></table>'),
					r, h, b, preview, linkParams = {};

				if(rows.length > 0){
                    // Headers
					if(data.draw_headers === undefined || data.draw_headers == true){
                        r = $('<tr style="color: rgb(0, 160, 175); font-weight: bold; text-transform: uppercase;"></tr>');
                        for (var i = 0; i < headers.length; i++) {
                            r.append($('<td align="left" style="padding: 8px;" valign="top"><label>' + headers[i].title + '</label></td>'));
                        }
                        t.append(r);
                    }

					// Body
					for (var i = 0; i < rows.length; i++) {
						r = $('<tr style="background-color: ' + ((i % 2) == 0 ? '#FFFFFF' : 'rgb(223, 240, 242)') + ';"></tr>');

						for (var j = 0; j < headers.length; j++) {
							if(headers[j].type == 'image' && rows[i][headers[j].json_map] != ''){
                                if(rows[i]['preview']){
                                    preview = '<span onclick="Hades.showDocument(\'' + rows[i][headers[j].json_map] + '\')" class="float_left ui-icon ui-icon-circle-zoomin" style="cursor: pointer;"></span>';
                                } else {
                                    preview = '';
                                }
								r.append($('<td align="left" style="padding: 8px; border-top: solid 1px #A9D9E0;" valign="top">' + preview + '<a target="_blank" href="' + rows[i][headers[j].json_map] + '"><img style="height: 16px;" src="/assets/clip_icon.png"></a></td>'));
							}
							else if(headers[j].type == 'icon' && rows[i][headers[j].json_map] != ''){
								r.append($('<td align="left" style="padding: 8px; border-top: solid 1px #A9D9E0;" valign="top"><div class="' + rows[i][headers[j].json_map] + '"></div></td>'));
							}
                            else if(headers[j].type == 'checkbox'){
                                r.append($('<td align="center" style="padding: 8px; border-top: solid 1px #A9D9E0;" valign="top"><input type="checkbox" disabled="disabled" '+(rows[i][headers[j].json_map]==true?'checked':'')+'></div></td>'));
                            }
                            else if(headers[j].type == 'two_lines'){
                                r.append($('<td align="left" style="padding: 8px; border-top: solid 1px #A9D9E0;" valign="top"><span style="font-weight: bold;">' + rows[i][headers[j].json_map_first] + '</span><br /><span style="font-weight: normal; font-style: italic;">' + rows[i][headers[j].json_map_second] + '</span></td>'));
                            }
                            else if(headers[j].type == 'link'){
                                r.append($('<td align="left" style="padding: 8px; border-top: solid 1px #A9D9E0;" valign="top"><label class="txt_link" data-url="'+rows[i]['url']+'" >' + rows[i][headers[j].json_map] + '</label></td>'));
                            }
                            else {
								r.append($('<td align="left" style="padding: 8px; border-top: solid 1px #A9D9E0;" valign="top"><label>' + rows[i][headers[j].json_map] + '</label></td>'));
							}
						}

						t.append(r);
					}
				} else {
					r = $('<tr style="font-style: italic;"><td style="padding: 4px 2px;"><label>' + data.no_data_msg + '</label></td></tr>');
					t.append(r);
				}

				w.find('.summary_widget_loading').hide();
				c.hide().append(t).fadeIn();
                //debug.log('data_clinical_notes', data);
				// Show/hide notification
				if(data.notification){
					$('#' + data.widget + ' .summary_widget_notification').show();
				} else {
					$('#' + data.widget + ' .summary_widget_notification').hide();
				}
				// Show/hide see more
				if(data.see_more){
					$('#' + data.widget + ' .summary_widget_more').show();
				} else {
					$('#' + data.widget + ' .summary_widget_more').hide();
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	},
	// To organize
	centerMenu: function(fix) {
		if (fix === undefined || fix == null) {
			fix = 0;
		}

		var topMargin = ($(window).height() - $('#metro-menu-ct').height() - fix /* explain later */ - 15) / 2;
		topMargin -= 85; // Remove top bar height
		topMargin = Math.max(0, topMargin);

		$('#metro-menu-ct').css('margin-top', topMargin + 'px');
	},
	editSection: function(button) {
		if ($(button).hasClass('disabled')) {
			return;
		}

		var ct = $(button).closest('.form_section');

		// Dim other sections
		$('.form_section:not(#' + $(ct).attr('id') + ')').animate({opacity:0.5});
		$('.form_section:not(#' + $(ct).attr('id') + ')').find('.edit_btn').addClass('disabled');

		// Hide edit button
		$(button).hide();

		// Show confirm and cancel buttons
		$(ct).find('.confirm_btn').show();
		$(ct).find('.cancel_btn').show();

		// Hide view container
		$(ct).find('.form_section_view').hide();

		// Show edit container
		$(ct).find('.form_section_edit').show();

		// Scroll to section
		$('#screen-content-holder').scrollTo($(ct));
	},
	cancelEditSection: function(button) {
		if ($(button).hasClass('disabled')) {
			return;
		}

		var ct = $(button).closest('.form_section');

		// Dim other sections
		$('.form_section:not(#' + $(ct).attr('id') + ')').animate({opacity:1});
		$('.form_section:not(#' + $(ct).attr('id') + ')').find('.edit_btn').removeClass('disabled');

		// Show edit button
		$(ct).find('.edit_btn').show();

		// Hide confirm and cancel buttons
		$(ct).find('.confirm_btn').hide();
		$(ct).find('.cancel_btn').hide();

		// Hide edit container
		$(ct).find('.form_section_edit').hide();

		// Show view container
		$(ct).find('.form_section_view').show();
	},
    slideContainer:function(ct){
        if($(ct).hasClass('ui-icon-triangle-1-n')){
            $(ct).removeClass('ui-icon-triangle-1-n').addClass('ui-icon-triangle-1-s');
        } else {
            $(ct).removeClass('ui-icon-triangle-1-s').addClass('ui-icon-triangle-1-n');
        }

        $('#' + $(ct).data('target')).slideToggle();
    },
    deserializeDate: function(date){
        var ret = null;

        if(date.length == 8){
            ret = new Date(
                date.substr(0, 4),
                date.substr(4, 2) - 1,
                date.substr(6, 2)
            );
        } else if(date.length == 12){
            ret = new Date(
                date.substr(0, 4),
                date.substr(4, 2) - 1,
                date.substr(6, 2),
                date.substr(8, 2),
                date.substr(10, 2)
            );
        } else if(date.length == 14){
            ret = new Date(
                date.substr(0, 4),
                date.substr(4, 2) - 1,
                date.substr(6, 2),
                date.substr(8, 2),
                date.substr(10, 2),
                date.substr(12, 2)
            );
        }

        return ret;
    },
    serializeDate: function(date){
        var
            dateParts = date.split('-'),
            dateMaskParts = Hades.getDateMask().split('-'),
            dateMask = Hades.getDateMask(),
            datePartsOrdered,
            serializedMask = 'yymmdd',
            ret = "";

        if(dateParts.length == 3 && dateMaskParts.length == 3){
            datePartsOrdered = [];

            for(var i = 0; i <  dateMaskParts.length; i++){
                datePartsOrdered.push({part: dateMaskParts[i], value: dateParts[i]});
            }

            ret = serializedMask;
            for(var i = 0; i < datePartsOrdered.length; i++){
                ret = ret.replace(datePartsOrdered[i].part, datePartsOrdered[i].value);
            }
        } else {
            debug.log('Invalid date or mask!', date, dateMask);
        }

        return ret;
    },
    stringToDate: function(date){
        var
            dateParts = date.split('-'),
            dateMaskParts = Hades.getDateMask().split('-'),
            datePartsOrdered,
            day,
            month,
            year,
            ret;

        if(dateParts.length == 3 && dateMaskParts.length == 3){
            datePartsOrdered = [];

            for(var i = 0; i <  dateMaskParts.length; i++){
                datePartsOrdered.push({part: dateMaskParts[i], value: dateParts[i]});
            }

            for(var i = 0; i < datePartsOrdered.length; i++){
                //["dd", "mm", "yy"]
                switch(datePartsOrdered[i].part){
                    case 'dd':
                        day = datePartsOrdered[i].value;
                        break;
                    case 'mm':
                        month = datePartsOrdered[i].value-1;
                        break;
                    case 'yy':
                        year = datePartsOrdered[i].value;
                        break;
                }
            }
        } else {
            debug.log('Invalid date or mask!', date, dateMask);
            return null;
        }

        return new Date(year, month, day);
    },
    formatDate: function(date){
        var _ret = Hades.getDateMask();
        _ret = _ret.replace('dd', date.getDate()>9?date.getDate():'0'+date.getDate());
        _ret = _ret.replace('mm', (date.getMonth()+1)>9?(date.getMonth()+1):'0'+(date.getMonth()+1));
        _ret = _ret.replace('yy', date.getFullYear());

        return _ret;
    },
    formatHour: function(date){
        var _ret = Hades.getHourMask();
        _ret = _ret.replace('hh', date.getHours()>9?date.getHours():'0'+date.getHours());
        _ret = _ret.replace('mm', date.getMinutes()>9?date.getMinutes():'0'+date.getMinutes());

        return _ret;
    },
    readURL: function(input, target, defaultValue) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $(target).attr('src', e.target.result);
            };

            reader.readAsDataURL(input.files[0]);
        } else if(defaultValue){
            $(target).attr('src', defaultValue);
        } else {
            $(target).attr('src', null);
        }
    },
    validateDate: function(date){
        var invalid = String(date).search(/^((\d+\d+|\d+)-(\d+\d+|\d+)-\d+\d+\d+\d+|\d+\d+\d+\d+-(\d+\d+|\d+)-(\d+\d+|\d+)|(\d+\d+|\d+)\/(\d+\d+|\d+)\/\d+\d+\d+\d+|\d+\d+\d+\d+\/(\d+\d+|\d+)\/(\d+\d+|\d+))$/);

        return (invalid == 0);
    },
    validateHour: function(hour){
        var invalid = String(hour).search(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/);

        return (invalid == 0);
    },

    // Convert from working local date (object or string) to server UTC in JSON format
    /* begin with JAVA services */
    fromLocalToServer: function(date, type) {
        if (!type){
            type = 'date'
        }
        var momentDate = moment(date);

        if (type === 'dateTime' || type === 'time') {
            momentDate = momentDate.utc()
        }

        if (type === 'dateTime') {
            return momentDate.toJSON()
        }

        return momentDate.format(helper.dateDefaultFormat.server[type])
    },

    fromServerToLocalString: function(date, type, dateFormat) {
        if (!type){
            type = 'date'
        }

        if (!date || isNaN(new Date(date).getTime())) {
            return
        }

        return moment.utc(date).local().format(dateFormat || helper.dateDefaultFormat.ux[type])
    },

    fromServerToLocalDate: function(date, type) {
        if (!type){
            type = 'date'
        }

        return moment.utc(date).local().toDate()
    },
    /* end with JAVA services */

    updateLookupList: function(field, list, propPrefix, options){
        var
            _field = $(field),
            item,
            op,
            propPrefix = (propPrefix?propPrefix:''),
            _options = {
                dataField: 'data',
                labelField: 'label',
                prevVal: _field.val()
            };

        _options = $.extend(_options, options);

        if(_field && list){
            // Clean specialties list
            _field.find('option').remove();

            // Create new list for specialties selector
            for (var i = 0; i < list.length; i++) {
                item = list[i];
                op = $('<option></option>');

                if(item[_options.dataField]==_options.prevVal){
                    $(op).attr('selected', 'selected');
                }

                $.each(item, function(key, value){
                    switch (key){
                        case _options.dataField:
                            $(op).attr('value', value);
                            break;
                        case _options.labelField:
                            $(op).html(value);
                            break;
                        default:
                            $(op).attr(propPrefix+key, value);
                            break;
                    }
                });
                _field.append(op);
            }

            _field.trigger('liszt:updated');
        } else {
            debug.log('Field or list not defined.', field, list);
        }
    },
    calculateDuration: function(startDate, endDate, duration){
        var
            _start = null,
            _end = null,
            _duration = null,
            _ret = null;

        try {
            _start = GlobalFn.stringToDate(startDate);

            if(duration){
                _duration = parseInt(duration);
                _end = GlobalFn.stringToDate(startDate);
                _end.setDate(_end.getDate()+_duration);
            } else {
                _end = GlobalFn.stringToDate(endDate);
                _duration = Math.ceil((_end-_start)/(24*60*60*1000));
            }

            _ret = {
                startDate: startDate,
                endDate: GlobalFn.formatDate(_end),
                duration: _duration
            };
        } catch(ex) {
            debug.log('calculateDuration', ex);
        }

        return _ret;
    },
    addNumeric: function(left, right){
        try {
            var _sum = new bigdecimal.BigDecimal(left.toString());
            _sum = _sum.add(new bigdecimal.BigDecimal(right.toString()));
            _sum = _sum.setScale(2, bigdecimal.RoundingMode.HALF_UP());

            return _sum.doubleValue();
        } catch(ex){
            debug.log(ex);

            return 0;
        }
    },
    openDatePicker: function(params, callback){
        Hades.showLoading();

        $.get('/modal/date_picker', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({
                    content: data,
                    autoScale: true,
                    autoDimensions: true,
                    // Give focus to first field
                    afterShow: function(){$('#date_picker_value').focus();}
                });

                if(callback){
                    $('#date-picker-modal-ct').bind('onConfirm', callback);
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    caret: function (elem, pos) {
        var target = elem[0];
        if (arguments.length == 0) { //get
            if (target.selectionStart) { //DOM
                var pos = target.selectionStart;
                return pos > 0 ? pos : 0;
            }
            else if (target.createTextRange) { //IE
                target.focus();
                var range = document.selection.createRange();
                if (range == null)
                    return '0';
                var re = target.createTextRange();
                var rc = re.duplicate();
                re.moveToBookmark(range.getBookmark());
                rc.setEndPoint('EndToStart', re);
                return rc.text.length;
            }
            else return 0;
        }

        var pos_start = pos;
        var pos_end = pos;

        if (arguments.length > 1) {
            pos_end = arguments[1];
        }

        if (target.setSelectionRange) //DOM
            target.setSelectionRange(pos_start, pos_end);
        else if (target.createTextRange) { //IE
            var range = target.createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos_end);
            range.moveStart('character', pos_start);
            range.select();
        }
    },
    toBoolean: function(val){
        if(val == true || val == 'true' || val == 't' || val == 1 || val == '1'){
            return true;
        }

        return false;
    },
    toPlainString:function(s){
        return $('<span></span>').html(s).text();
    },
    onMultiSelectChange: function(evt, changes) {
        if(changes && changes.selected == '-999'){
            $.each($(this).find('option'), function (index, elem) {
                if ($(elem).val() == '-999') {
                    $(elem).prop('selected', false);
                } else {
                    $(elem).prop('selected', 'selected');
                }
            });

            $(this).trigger('liszt:updated');
        }
    },
    findElementInArrayByPropValue: function (arr, propName, propValue) {
        var elem =  null;

        $.each(arr, function( index, value ) {
            if (value[propName] == propValue){
                elem = value;

                return elem;
            }
        });

        return elem;
    },
    deleteElementInArrayByPropValue: function (arr, propName, propValue) {
        var deleted = false;

        var delete_index = null;

        $.each(arr, function( index, value ) {
            if (value[propName] === propValue){

                delete_index = index;

                deleted = true;

            }
        });

        if (delete_index != null){
            arr.splice(delete_index, 1);
        }

        return deleted;
    },
    validateChar: function (evt, elem) { // Verify double

        var charCode = (evt.which) ? evt.which : evt.keyCode;

        if (charCode > 31 && (charCode != 46 && (charCode < 48 || charCode > 57)))
            return false;
        else {
            var dot = 0;
            for (var i = 0; i < elem.value.toString().length; i++) {
                if (elem.value.toString()[i] == '.')
                    dot++;
            }
            if (charCode == 46 && dot == 1)
                return false;
        }
        return true;
    },
    validateQuantities: function (evt, elem) { // Verify three digits counting with '/' and '.'
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        let inputValue = elem.value.toString();

    
        if ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 47) {
            if (inputValue.length === 3) {
                return false;
            }

            if ((charCode === 46 || charCode === 47) && (inputValue.includes('.') || inputValue.includes('/'))) {
                return false;
            }
        } else {
            return false;
        }
    
        return true;
    },
    validateNumberChar: function (evt) { // Verify integer

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    },
    validateCharAllowNegativeValues: function (evt, elem) {

        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && charCode != 46 && charCode != 45 && (charCode < 48 || charCode > 57))
            return false;
        else {
            var dot = 0;

            for (var i = 0; i < elem.value.toString().length; i++) {
                if (elem.value.toString()[i] == '.')
                    dot++;
            }
            if (charCode == 46 && dot == 1) {
            return false;
            }
        }
        return true;
    },

    SetRestrictionOffSet: function (list, period, date, financial_institution) {

        /*debug.log("SetRestrictionOffSet Params");
        debug.log("period", period);
        debug.log("date", date);
        debug.log("date", financial_institution);
        debug.log("-------------------------");*/

        var _offSet = 0;

        //debug.log("list",list);
        $.each(list, function(index, restriction) {

            /*debug.log("SetRestrictionOffSet Each");
            debug.log("restriction.date", restriction.date);
            debug.log("restriction.period", restriction.period_id);
            debug.log("restriction.period", restriction.financial_institution_id);*/

            if (restriction.date == date && restriction.period_id == period && restriction.financial_institution_id == financial_institution){

                _offSet = _offSet + 1;

            }

        });

        return _offSet;

    }
};


